import React from 'react';
import { Box } from 'reactjs-admin-lte';
import { Table } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Rating from 'react-rating';


const UserFocus = (props) => {

  const {
    isLoading,
    collapsed,
    focus,
    hasHeader,
    handleChange
  } = props;

  const renderRow = () => {
    return focus.map(row => {
      return (
        <React.Fragment key={row.id}>
          <tr className="active">
            <td><strong>{row.name}</strong></td>
            <td></td>
          </tr>
          {row.children.map(child => (
            <tr key={child.industryId}>
              <td>{child.industryName}</td>
              <td>
                <FontAwesome
                  name="ban"
                  className="mr-3"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleChange(
                    child.focusId,
                    child.industryId,
                    0
                  )} />
                <Rating
                  emptySymbol="fa fa-star-o"
                  fullSymbol="fa fa-star"
                  initialRating={child.level}
                  onChange={rate => handleChange(
                    child.focusId,
                    child.industryId,
                    rate
                  )} />
                </td>
            </tr>
          ))}
      </React.Fragment>
    )});
  }

  return (
    <Box
      className="box-widget mb-0"
      loading={isLoading}
      collapsed={collapsed}>
      { hasHeader &&
        <Box.Header border={true}>
          <Box.Title>Focus</Box.Title>
          <Box.Tools>
            <Box.CollapsedToggleButton />
          </Box.Tools>
        </Box.Header>
      }
      <Box.Body noPadding={true}>
        <Table>
          <thead>
            <tr>
              <th>Industry</th>
              <th width="20%">Level</th>
            </tr>
          </thead>
          <tbody>
            {renderRow()}
          </tbody>
        </Table>
      </Box.Body>
    </Box>
  )
}

UserFocus.defaultProps = {
  hasHeader: false,
  collapsed: false
}

export default UserFocus;